/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Request body for generating a new VMUA RSA key pair in simple (global) mode.
 */
export interface VmuaGenerateKeyRequest { 
    /**
     * Software version string to associate with this key (e.g. \"9.0.2\"). Required because global-mode keys have no vvmua_entities record to look up.
     */
    entityVersion: string;
}

